// Components
import Grid from 'components/collection/grid'
import BeatList from 'components/beat/beatlist'
import UserLayout from 'components/profile/userlayout'
import SEO from 'components/base/seo'
import { Spinner, Error } from '@tracklib/kit'

// Hooks
import { useProfile } from 'modules/profile/hooks'
import { useRequest } from 'modules/requests/hooks'

// Utils
import { isBrowser } from '@process'

const ProfilePage = () => {
  const profile = useProfile()
  const profileRequest = useRequest('FETCH_PROFILE')

  if (!profile) {
    if (profileRequest.isLoading || !isBrowser) {
      return <Spinner minHeight={500} delay={0} />
    } else {
      return <Error />
    }
  }
  const title = profile.alias ? `@${profile.alias} | Tracklib` : 'Profile | Tracklib'
  return (
    <>
      <SEO title={title} />
      <UserLayout user={profile}>
        <BeatList userId={profile.user} />
        <Grid
          heading="Collections"
          searchQuery={`?owner=${profile.user}`}
          emptyStateTitle="You have no collections yet"
          emptyStateSubtitle="Search through our library and create collections to save and organize the tracks you like."
        />
      </UserLayout>
    </>
  )
}

export default ProfilePage
